import { ISelectItem } from '@lla-platform/core/core-ui'
import { UsafOrderSource } from './usaf-order-source.enum'

// Values match the BE status vocabulary (UsafProvider/Constants/UsafOrderStatuses.cs) —
// Status is a plain string column, not an enum.
export const UsafOrderStatuses = {
  pending: 'pending',
  failed: 'failed',
  open: 'open',
  invoiced: 'invoiced',
  canceled: 'canceled',
  credits: 'credits',
  unknown: 'unknown'
}

export const UsafOrderStatusItems: ISelectItem[] = [
  { label: 'Open', value: UsafOrderStatuses.open },
  { label: 'Invoiced', value: UsafOrderStatuses.invoiced },
  { label: 'Pending', value: UsafOrderStatuses.pending },
  { label: 'Failed', value: UsafOrderStatuses.failed },
  { label: 'Canceled', value: UsafOrderStatuses.canceled },
  { label: 'Credits', value: UsafOrderStatuses.credits },
  { label: 'Unknown', value: UsafOrderStatuses.unknown }
]

export const UsafOrderSourceItems: ISelectItem[] = [
  { label: 'Jarvis', value: UsafOrderSource.Jarvis },
  { label: 'External (USAF site)', value: UsafOrderSource.Usaf },
  { label: 'Invoice', value: UsafOrderSource.Invoice },
  { label: 'Daily Refill', value: UsafOrderSource.DailyRefill },
  { label: 'Manual Refill', value: UsafOrderSource.ManualRefill }
]

export const UsafOrderSourceLabels: Record<string, string> = Object.fromEntries(
  UsafOrderSourceItems.map((el) => [el.value, el.label])
)

// Placed with no person behind it: sale-replacement and the Daily Refill cron.
export function isUnattendedUsafOrderSource(source?: UsafOrderSource): boolean {
  return source === UsafOrderSource.Invoice || source === UsafOrderSource.DailyRefill
}

export const UsafInvoiceStatusItems: ISelectItem[] = [
  { label: 'Paid', value: 'paid' },
  { label: 'Unpaid', value: 'unpaid' },
  { label: 'SSP', value: 'ssp' },
  { label: 'Refunded', value: 'refunded' },
  { label: 'Pending', value: 'pending' }
]
